const Expired = () => {
  return (
    <>
      <p className="header">Brak dostępu do wniosku.</p>
      <p>
        Możliwe, że wniosek został już złożony lub link do wniosku jest
        nieaktywny. Skontaktuj się z Partnerem Xelion.
      </p>
    </>
  );
};

export { Expired };
